export class ConstService {
    public static readonly ALL_TICKETS = 9999;
    public static readonly TOURNAMENTS_SITNGO = 0;
    public static readonly SITNGO_HERO = 3;
    public static readonly INACTIVE_TICKETS = -1;
    public static readonly OFFLINE_TICKETS = 1;
    public static readonly SITNGO = 2;
}
